import React, { LegacyRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleQuestion } from "@fortawesome/pro-solid-svg-icons";
import { faCircleQuestion as faRegularCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import Tooltip from "../tooltip/Tooltip";

import "./Textarea.scss";

interface IProps {
    error?: boolean | undefined;
    success?: boolean | undefined;
    filedtitle?: React.ReactNode | undefined;
    help?: React.ReactNode | undefined;
    postchildren?: React.ReactNode | undefined;
    prechildren?: React.ReactNode | undefined;
    maxHeight?: number | undefined;
}

const Textarea = React.forwardRef(
    (
        props: IProps & React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>,
        ref: LegacyRef<HTMLTextAreaElement>,
    ) => {
        const insertTitleOrHelp = props.filedtitle || props.help;
        const insertPreChildren = props.prechildren || insertTitleOrHelp;

        return (
            <div className="textarea-field-wrapper">
                {insertPreChildren && (
                    <div
                        className={`textarea-field-header ${props.error ? "textarea-field-error" : ""}${props.success ? "textarea-field-success" : ""}`}
                    >
                        {insertTitleOrHelp && (
                            <div className={`textarea-field-title-container`}>
                                {props.filedtitle && <p>{props.filedtitle}</p>}
                                {props.help && (
                                    <Tooltip title={props.help}>
                                        <FontAwesomeIcon icon={faRegularCircleQuestion} />
                                    </Tooltip>
                                )}
                            </div>
                        )}
                        {props.prechildren}
                    </div>
                )}
                <textarea
                    className="userful-textarea-field"
                    id={`${props.error ? "textarea-field-error" : ""}${props.success ? "textarea-field-success" : ""}`}
                    {...props}
                    ref={ref}
                    style={{ maxHeight: props.maxHeight ? props.maxHeight : "" }}
                />
                {props.postchildren && (
                    <div
                        className={`textarea-field-container ${props.error ? "textarea-field-error" : ""}${props.success ? "textarea-field-success" : ""}`}
                    >
                        {props.error && <FontAwesomeIcon icon={faCircleQuestion} />}
                        {props.success && <FontAwesomeIcon icon={faCheckCircle} />}
                        {props.postchildren}
                    </div>
                )}
            </div>
        );
    },
);

export default Textarea;
